import { render } from "./TemplateDbsUnlocking.vue?vue&type=template&id=3a078286&scoped=true"
import script from "./TemplateDbsUnlocking.vue?vue&type=script&lang=js"
export * from "./TemplateDbsUnlocking.vue?vue&type=script&lang=js"

import "./TemplateDbsUnlocking.vue?vue&type=style&index=0&id=3a078286&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a078286"

export default script